import { render, staticRenderFns } from "./sonstiges.vue?vue&type=template&id=095b47b4&scoped=true&"
import script from "./sonstiges.vue?vue&type=script&lang=js&"
export * from "./sonstiges.vue?vue&type=script&lang=js&"
import style0 from "./sonstiges.vue?vue&type=style&index=0&id=095b47b4&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095b47b4",
  null
  
)

export default component.exports